import { Box, Image } from '@opendoor/bricks-next';

const imgDropUrl = (id: string) =>
  `https://images.opendoor.com/source/s3/imgdrop-production/${id}?preset=square-1024&service=cosmos&dpr=2`;

export const FiveUserImageRow = () => {
  return (
    <Box>
      {/* smaller image */}
      <Image
        display="inline"
        $largerThanSM={{ display: 'none' }}
        source={{
          uri: imgDropUrl('2025-11-1763666953751-13372.png'),
          width: 136,
          height: 40,
        }}
        alt="A series of 5 overlapping avatars of Opendoor users"
      />
      {/* larger image */}
      <Image
        display="none"
        $largerThanSM={{ display: 'inline' }}
        source={{
          uri: imgDropUrl('2025-11-1763666953751-13372.png'),
          width: 176,
          height: 52,
        }}
        alt="A series of 5 overlapping avatars of Opendoor users"
      />
    </Box>
  );
};
